module.exports = __webpack_public_path__ + "img/short.cc13b8d9.svg";